// Archive Assignment
export const ARCHIVE_ASSIGNMENT_REQUEST = 'ARCHIVE_ASSIGNMENT_REQUEST';
export const ARCHIVE_ASSIGNMENT_DONE = 'ARCHIVE_ASSIGNMENT_DONE';
export const ARCHIVE_ASSIGNMENT_FAILED = 'ARCHIVE_ASSIGNMENT_FAILED';
